// Pages/Inventory/Adjustments/Form.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
    create_inventory_adjustment,
    get_inventory_adjustment,
    update_inventory_adjustment,
} from "../../../../Controllers/Inventory/Adjustment";
import { get_inventory } from "../../../../Controllers/Inventory/Batch";
import forms from "../../../../Data/Forms/Inventory/Adjustment/forms";
import headers from "../../../../Data/Forms/Inventory/Adjustment/headers";
import Loadercomponent from "../../../../Componets/Loader";

const InventoryAdjustmentsForm = () => {
    let { id } = useParams();
    let navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [header, setHeader] = useState(headers);
    const [values, setValues] = useState(forms);

    // when inventory batch is selected, auto-populate read-only details
    const getformdata = async (data) => {
        if (data?.inventory) {
            const inventory = await get_inventory({ id: data?.inventory });

            if (inventory?.status) {
                values[0].options[0].form.value = data?.inventory;

                values[1].options[0].form.value = inventory?.data?.product?.name;
                values[1].options[1].form.value = inventory?.data?.stock;
                values[1].options[2].form.value = inventory?.data?.purchase_price;
                setValues([...values]);
            }
        }
    };

    const formdata = async (data) => {
        if (data?.status) {
            setButtonLoader(true);

            const adjustment = id
                ? await update_inventory_adjustment({ ...data?.data, id: id })
                : await create_inventory_adjustment(data?.data);

            if (adjustment?.status) {
                navigate(-1);
                toast?.success(adjustment?.message);
                setButtonLoader(false);
            } else {
                setButtonLoader(false);
                if (adjustment?.status_code == 403) {
                    window.location.href = "/unauthorized";
                } else {
                    toast?.error(adjustment?.message);
                }
            }
        }
    };

    const handleData = (adjustment) => {
        // inventory batch field
        values[0].options[0].form.value = adjustment?.inventory?._id;
        values[0].options[0].form.options = adjustment?.inventory?._id
            ? [{ value: adjustment?.inventory?._id, label: `#BATCH-${adjustment?.inventory?.number}` }]
            : null;

        // read-only details
        values[1].options[0].form.value = adjustment?.inventory?.product?.name;
        values[1].options[1].form.value = adjustment?.stock_before; // show stock at time of adjustment
        values[1].options[2].form.value = adjustment?.inventory?.purchase_price;

        // adjustment fields
        values[2].options[0].form.value = adjustment?.type;
        values[2].options[1].form.value = adjustment?.quantity;
        values[2].options[2].form.value = adjustment?.reason;
        values[2].options[3].form.value = adjustment?.note;
        values[2].options[4].form.value = adjustment?.date;
        values[2].options[5].form.value = adjustment?.image;

        setLoader(false);
        setValues([...values]);
    };

    const fetchData = async () => {
        if (id) {
            setLoader(true);

            const adjustment = await get_inventory_adjustment({ id });

            if (adjustment?.status) {
                handleData(adjustment?.data);
            } else {
                if (adjustment?.status_code == 403) {
                    window.location.href = "/unauthorized";
                } else {
                    toast?.error(adjustment?.message);
                }
            }
        } else {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            <Loadercomponent loader={loader}>
                <Forms
                    form={values}
                    setForm={setValues}
                    formdata={formdata}
                    buttonLoader={buttonLoader}
                    getformdata={getformdata}
                />
            </Loadercomponent>
        </Header>
    );
};

export default InventoryAdjustmentsForm;